var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview_textSetting p10"},[_vm._v("此处分页")])}
var staticRenderFns = []

export { render, staticRenderFns }